import axiosProtected from "../../../../../api/config/baseWithToken";

export const handleDisputeMessagesAPI = async (body) => {
  try {
    const { data } = await axiosProtected.post("/store/conversations", body);
   
    return {
      conversations: data?.conversation?.conversations,
    };
  } catch (error) {
    console.log(error);
  }
};

export const getConversationsByDispute = async (disputeId) => {
  try {
    const { data } = await axiosProtected.get(`/store/conversations/${disputeId}`);
    return {
      conversations: data?.conversation?.conversations,
    };
  } catch (error) {
    console.log(error);
  }
};
